import React, { useEffect } from "react";
import "../styles/SportsID.css"; 

const SportsID = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="sports-id-page">

      <div className="sports-id-header">
        <h1><span className="highlight">Mahadev</span> Sports ID – Play Smart, Win Big</h1>
        <p>
          Unlock the power of real-time betting with Mahadev Sports ID. Designed for passionate sports fans, our Sports ID gives you access to the most trusted platforms, lightning-fast updates, and seamless betting experiences across multiple sports.
        </p>
      </div>

      {/* Sports ID Section */}
      <div className="sports-id-section">

        {/* Cricket Card */}
        <div className="sports-id-card">
          <h2 className="sports-id-card-title">Cricket</h2>
          <p>
            Dive into the cricketing world with access to top leagues like IPL, BBL, and T20 internationals. With Mahadev Sports ID, follow real-time odds, match stats, and place bets with ease — whether it's pre-match or in-play.
          </p>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="sports-btn contactus-button"
          >
            Reach Us @8888568888
          </a>
        </div>

        {/* Football Card */}
        <div className="sports-id-card">
          <h2 className="sports-id-card-title">Football</h2>
          <p>
            From the Premier League to the World Cup, follow all major football action. Mahadev Sports ID gives you access to stats, score predictions, and intuitive betting tools to support your strategies.
          </p>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="sports-btn contactus-button"
          >
            Reach Us @8888568888
          </a>
        </div>

        {/* Tennis Card */}
        <div className="sports-id-card">
          <h2 className="sports-id-card-title">Tennis</h2>
          <p>
            Bet on Grand Slams and ATP/WTA tours with accurate analytics and live tracking. Mahadev Sports ID ensures you don’t miss a single serve or volley, whether it's a final showdown or a surprise upset.
          </p>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="sports-btn contactus-button"
          >
            Reach Us @8888568888
          </a>
        </div>

        {/* Horse Racing Card */}
        <div className="sports-id-card">
          <h2 className="sports-id-card-title">Horse Racing</h2>
          <p>
            Ride the wave of excitement with real-time updates from races around the world. Place strategic bets on your favorites and access expert predictions, race forms, and speed ratings instantly.
          </p>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="sports-btn contactus-button"
          >
            Reach Us @8888568888
          </a>
        </div>

        {/* Kabaddi Card */}
        <div className="sports-id-card">
          <h2 className="sports-id-card-title">Kabaddi</h2>
          <p>
            Kabaddi’s popularity is skyrocketing! Bet on PKL and international tournaments with Mahadev’s smart dashboard — offering live scores, player stats, and pre-match odds tailored for kabaddi lovers.
          </p>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="sports-btn contactus-button"
          >
            Reach Us @8888568888
          </a>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="sports-id-cta">
        <h2 className="cta-title"><span className="highlight">Get Your</span> Sports ID Today!</h2>
        <p>
          Join the league of winners with Mahadev Sports ID. From cricket to kabaddi, place your bets smartly with our reliable support and platform integration. Instant activation, full assistance — just one click away.
        </p>
        <div className="sports-bttn">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            WhatsApp Us @8888568888
          </a>
        </div>
      </div>
    </div>
  );
};

export default SportsID;
